export default "__VITE_ASSET__BER1gWCv__"